import styled from 'styled-components';
import { container, flexPosition } from '../../styles/mixins';

export const Container = styled.div`
  ${container()}
  ${flexPosition({
    align: 'flex-start',
    justify: 'space-between',
  })}
  margin-bottom: 135px;
  margin-top: 20px;
`;



// WEBPACK FOOTER //
// ./src/components/VariationDragDrop/style.js